import React from 'react'
import { Typography } from '@telavita-core/react-design-kit'
import { parsePhoneNumber } from 'libphonenumber-js'
import { format } from 'date-fns'

interface PatientInfoProps {
  fullName: string
  username: string
  phoneNumber: string
  creationDate: Date
}

export const PatientInfo: React.FC<PatientInfoProps> = ({ fullName, username, phoneNumber, creationDate }) => (
  <div>
    <Typography variant='content2' weight='bolder'>
      {fullName}
    </Typography>
    <Typography variant='content2'>
      {username}
    </Typography>
    <Typography variant='content2'>
      {isNaN(Number(phoneNumber)) ? '' : parsePhoneNumber(`+${phoneNumber}`).formatNational()}
    </Typography>
    
    <Typography variant='content3' weight='bold' inlineStyles={{ marginTop: '40px' }}>
      Criada em {format(creationDate, 'dd/MM/yyyy')}
    </Typography>
    
  </div>
)